import React, { useState } from 'react';
import { Card, Form, Input, Button, Row, Col, message, Modal } from 'antd';
import { useGetProfileQuery, useUpdateProfileMutation, useChangePasswordMutation } from '../../store/api/authApi';
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/slices/authSlice';
import { useEffect } from 'react';

const ProfilePage: React.FC = () => {
  const { data: profile, isLoading } = useGetProfileQuery();
  const [updateProfile] = useUpdateProfileMutation();
  const [changePassword] = useChangePasswordMutation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  // Когда профиль загрузился — заполняем форму
  useEffect(() => {
    if (profile) {
      form.setFieldsValue({
        username: profile.username,
        email: profile.email,
        firstName: profile.firstName,
        lastName: profile.lastName,
        phone: profile.phone
      });
    }
  }, [profile, form]);

  const [isPwdModalVisible, setIsPwdModalVisible] = useState(false);

  const handleSave = async (values: any) => {
    try {
      const res = await updateProfile({
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName
      }).unwrap();
      message.success('Профиль обновлён');
      dispatch(setUser(res));
    } catch (err: any) {
      console.error(err);
      message.error(err?.data?.error || 'Ошибка обновления профиля');
    }
  };

  const handleChangePassword = async (values: any) => {
    try {
      await changePassword(values).unwrap();
      message.success('Пароль успешно изменён');
      setIsPwdModalVisible(false);
    } catch (err: any) {
      console.error(err);
      message.error(err?.data?.error || 'Ошибка смены пароля');
    }
  };

  return (
    <Row gutter={16} style={{ padding: 16 }}>
      <Col span={12}>
        <Card title="Мой профиль" loading={isLoading}>
          <Form
            form={form}
            layout="vertical"
            // initialValues остаётся пустым — используем setFieldsValue при загрузке профиля
            onFinish={handleSave}
          >
            <Form.Item label="Логин" name="username">
              <Input disabled />
            </Form.Item>

            <Form.Item label="Email" name="email" rules={[{ type: 'email', message: 'Неверный email' }, { required: true }] }>
              <Input />
            </Form.Item>

            <Form.Item label="Имя" name="firstName">
              <Input />
            </Form.Item>

            <Form.Item label="Фамилия" name="lastName">
              <Input />
            </Form.Item>

            <Form.Item label="Телефон" name="phone">
              <Input />
            </Form.Item>

            <Form.Item label="Роль">
              <Input value={profile?.role?.name || ''} disabled />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">Сохранить</Button>
              <Button style={{ marginLeft: 8 }} onClick={() => setIsPwdModalVisible(true)}>Сменить пароль</Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>

      <Modal
        title="Сменить пароль"
        open={isPwdModalVisible}
        onCancel={() => setIsPwdModalVisible(false)}
        footer={null}
      >
        <Form layout="vertical" onFinish={handleChangePassword}>
          <Form.Item name="currentPassword" label="Текущий пароль" rules={[{ required: true }]}> 
            <Input.Password />
          </Form.Item>
          <Form.Item name="newPassword" label="Новый пароль" rules={[{ required: true, min: 6 }]}> 
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">Сменить</Button>
          </Form.Item>
        </Form>
      </Modal>
    </Row>
  );
};

export default ProfilePage;


